<!--
    描述：支付会员页面
    Created by asq
-->
<template>
	<div class="h100 register-main">
	  <filter-layout @search="doSearch" @reset="resetSerach" hasMore>
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchForm"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="会员名称：" prop="sname">
			  <el-input
				:placeholder="'请输入'"
				clearable
				size="small"
				v-model="searchForm.sname"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="会员ID：" prop="bizUserid">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchForm.bizUserid"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="会员状态：" prop="isFlag">
			  <el-select
				v-model="searchForm.isFlag"
				filterable
				size="small"
				placeholder="请选择"
			  >
				<el-option label="全部" value=""></el-option>
				<el-option label="有效" :value="1"></el-option>
				<el-option label="无效" :value="0"></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="会员类型：" prop="memberType">
			  <el-select
				v-model="searchForm.memberType"
				filterable
				size="small"
				placeholder="请选择"
			  >
				<el-option
				  v-for="(item, index) in zhzt"
				  :key="index"
				  :label="item.sname"
				  :value="item.value"
				>
				</el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>
		<template #more>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchForm"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="创建时间：" prop="startTime" class="w50">
			  <div style="display: flex">
				<el-date-picker
				  v-model="searchForm.startTime"
				  type="date"
				  size="small"
				  placeholder="请选择"
				  value-format="yyyy-MM-dd"
				  :clearable="false"
				  :picker-options="startDatePicker"
				>
				</el-date-picker>

				<span class="text-center pd5">~</span>

				<el-date-picker
				  v-model="searchForm.endTime"
				  type="date"
				  size="small"
				  placeholder="请选择"
				  value-format="yyyy-MM-dd"
				  :clearable="false"
				  :picker-options="endDatePicker"
				>
				</el-date-picker>
			  </div>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title">
			  会员合计：<span class="blue">{{ totalMember }}</span> 个
			</div>
			<div class="btnGroups">
			  <!-- <el-button
				type="primary"
				class="btn-blue"
				size="mini"
				@click="changeState"
			  >
				筛选
				<i v-if="searchToggle" class="el-icon-caret-top ml5"></i>
				<i v-else class="el-icon-caret-bottom ml5"></i>
			  </el-button> -->
			  <el-button
				type="primary"
				class="ml5 btn-blue"
				size="mini"
				@click="resetSerach"
			  >
				<i class="el-icon-refresh"></i>
			  </el-button>
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow">
			  <el-table
				ref="xTable"
				:data="filterData"
				highlight-current-row
				height="100%"
				size="mini"
				border
			  >
				<el-table-column
				  type="index"
				  label="序号"
				  align="center"
				  width="80"
				></el-table-column>
				<el-table-column
				  prop="bizUserid"
				  label="会员ID"
				  header-align="center"
				  width="220"
				  show-overflow-tooltip
				>
				</el-table-column>
				<el-table-column
				  prop="sname"
				  label="会员名称"
				  header-align="center"
				  min-width="180"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="memberType"
				  label="会员类型"
				  align="center"
				  width="210"
				  show-overflow-tooltip
				>
				  <template slot-scope="scope">
					<span v-if="scope.row.memberType == 1">平台会员</span>
					<span v-if="scope.row.memberType == 2">企业会员</span>
					<span v-else-if="scope.row.memberType == 3">个人会员</span>
				  </template>
				</el-table-column>
				<!-- <el-table-column
								prop="tiedPhone"
								label="绑定手机"
								width="180"
								align="center"
								sortable
								show-overflow-tooltip
							></el-table-column> -->
				<el-table-column
				  prop="isFlag"
				  label="会员状态"
				  width="150"
				  align="center"
				  show-overflow-tooltip
				>
				  <template slot-scope="scope">
					<span class="blue-state" v-if="scope.row.isFlag == 1"
					  >有效</span
					>
					<span class="red-state" v-else-if="scope.row.isFlag == 0"
					  >无效</span
					>
				  </template>
				</el-table-column>
				<!-- <el-table-column prop="isReal"
						 label="是否实名认证"
						 width="150"
						 align="center"
						 show-overflow-tooltip>
				  <template slot-scope="scope">
					<span class="no-real"
						v-if="scope.row.isReal == 0">否</span>
					<span class="real"
						v-else-if="scope.row.isReal == 1">是</span></template>
				</el-table-column> -->
				<!-- <el-table-column
								prop="userName"
								label="创建人"
								width="150"
								align="center"
								sortable
								show-overflow-tooltip
							></el-table-column> -->
				<el-table-column
				  prop="createDate"
				  label="创建时间"
				  width="200"
				  align="center"
				  sortable
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column align="center" label="操作" width="240">
				  <template slot-scope="scope">
					<el-button
					  type="primary"
					  size="small"
					  class="table-btn"
					  round
					  plain
					  v-if="roleBtns.includes('detailInfo')"
					  @click="showDeatil(scope.row)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
					<el-button
					  type="primary"
					  size="small"
					  class="table-btn"
					  round
					  plain
					  v-if="roleBtns.includes('bankCardInfo')"
					  @click="showCard(scope.row)"
					>
					  <svg-icon icon-class="form-bank-card"></svg-icon> 银行卡信息
					</el-button>
				  </template>
				</el-table-column>
			  </el-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageList"
				:page-size="pageSize"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>

		<!-- 弹窗 -->
		<el-dialog
		  :title="dialogObj.title"
		  :visible.sync="dialogObj.visible"
		  :width="dialogObj.width"
		  @closed="handleClose"
		  center
		>
		  <template v-if="dialogObj.mode == 'detail'">
			<div style="line-height: 40px">
			  <el-row>
				<el-col :span="12">
				  <span class="label-text"> 会员id：</span>
				  <span class="label-msg">{{ dialogData.bizUserid }}</span>
				</el-col>

				<el-col :span="12">
				  <span class="label-text">会员名称：</span>
				  <span class="label-msg borderr">{{ dialogData.sname }}</span>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="12">
				  <span class="label-text">会员类型：</span>
				  <span v-if="dialogData.memberType == 2" class="label-msg"
					>企业会员</span
				  >
				  <span v-if="dialogData.memberType == 3" class="label-msg"
					>个人会员</span
				  >
				</el-col>
				<el-col :span="12">
				  <span class="label-text">绑定手机号：</span>
				  <span class="label-msg borderr">{{
					dialogData.tiedPhone
				  }}</span>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="12">
				  <span class="label-text borderb">证件类型：</span>
				  <span class="label-msg borderb">{{ dialogData.cardType }}</span>
				</el-col>
				<el-col :span="12">
				  <span class="label-text borderb">证件号：</span>
				  <span class="label-msg borderb borderr">{{
					dialogData.idCard
				  }}</span>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="12">
				  <span class="label-text borderb">会员状态：</span>
				  <span v-if="dialogData.isFlag == 0" class="label-msg borderb"
					>无效</span
				  >
				  <span v-if="dialogData.isFlag == 1" class="label-msg borderb"
					>有效</span
				  >
				</el-col>
				<el-col :span="12">
				  <span class="label-text borderb">创建时间：</span>
				  <span class="label-msg borderb borderr">{{
					dialogData.createDate
				  }}</span>
				</el-col>
			  </el-row>
			  <!-- <el-row>
			<el-col :span="12">
			  <span class="label-text borderb">是否实名：</span>
			  <span class="label-msg borderb">{{ dialogData.type }}</span>
			</el-col>
			<el-col :span="12">
			  <span class="label-text borderb">实名时间：</span>
			  <span class="label-msg borderb borderr">{{
								dialogData.updateDate
							}}</span>
			</el-col>
		  </el-row> -->
			  <!-- <el-row>
			<el-col :span="12">
			  <span class="label-text borderb">是否签订协议：</span>
			  <span class="label-msg borderb">{{
								dialogData.agreeType
							}}</span>
			</el-col>
			<el-col :span="12">
			  <span class="label-text borderb">电子协议签订时间：</span>
			  <span class="label-msg borderb borderr">{{
								dialogData.agreeUpdateDate
							}}</span>
			</el-col>
		  </el-row> -->
			</div>
		  </template>
		  <template
			v-if="dialogObj.mode == 'showCard'"
			style="text-align: center"
		  >
			<div class="title">
			  会员类型：<span v-if="this.memberType == 2" class="blue"
				>企业会员</span
			  >
			  <span v-if="this.memberType == 3" class="blue">个人会员</span>
			</div>
			<el-table :data="dialogData2" border v-if="this.memberType == 3">
			  <el-table-column
				prop="account"
				label="卡号"
				header-align="center"
				show-overflow-tooltip
				min-width="140"
			  >
			  </el-table-column>
			  <el-table-column
				prop="sname"
				label="姓名"
				align="center"
				width="80"
			  >
			  </el-table-column>
			  <el-table-column
				prop="codeName"
				align="center"
				label="证件类型"
				show-overflow-tooltip
				width="110"
			  >
			  </el-table-column>
			  <el-table-column
				prop="code"
				header-align="center"
				label="证件号"
				show-overflow-tooltip
				width="120"
			  >
			  </el-table-column>
			  <el-table-column
				prop="tiedPhone"
				align="center"
				label="绑定手机号"
				width="100"
			  >
			  </el-table-column>
			  <el-table-column
				prop="bank"
				header-align="center"
				label="发卡行"
				width="140"
			  >
			  </el-table-column>
			  <el-table-column
				prop="address"
				header-align="center"
				label="卡类型"
				width="80"
			  >
			  </el-table-column>
			</el-table>
			<el-table :data="dialogData2" border v-if="this.memberType == 2">
			  <el-table-column
				prop="account"
				label="对公账户"
				header-align="center"
				show-overflow-tooltip
				min-width="140"
			  >
			  </el-table-column>
			  <el-table-column
				prop="sname"
				label="企业名称"
				show-overflow-tooltip
				header-align="center"
				width="120"
			  >
			  </el-table-column>
			  <el-table-column
				prop="codeName"
				align="center"
				show-overflow-tooltip
				label="证件类型"
				width="100"
			  >
			  </el-table-column>
			  <el-table-column
				prop="code"
				header-align="center"
				label="证件号"
				show-overflow-tooltip
				width="120"
			  >
			  </el-table-column>
			  <el-table-column
				prop="tiedPhone"
				align="center"
				label="绑定手机号"
				width="110"
			  >
			  </el-table-column>
			  <el-table-column
				prop="bank"
				header-align="center"
				label="发卡行"
				width="140"
			  >
			  </el-table-column>
			  <el-table-column
				prop="agreeType"
				align="center"
				label="是否签订协议"
				width="120"
			  >
			  </el-table-column>
			  <el-table-column
				prop="agreeUpdateDate"
				align="center"
				label="电子协议签订时间"
				width="150"
			  >
			  </el-table-column>
			</el-table>
		  </template>
		  <!-- footer 组件 -->
		  <!-- <div slot="footer"
		 class="pdb10 text-center">
		<el-button size="small"
			   @click="dialogObj.visible = false">取 消
		</el-button>
		<el-button type="primary"
			   size="small"
			   class="btn-blue"
			   @click="confirm">确 定
		</el-button>
	  </div> -->
		</el-dialog>
	  </filter-layout>
	</div>
  </template>
<script>
import {
	getBankInfo,
	getDetails,
	selectAllPage,
} from "api/modules/paymentSettlement";
import { mapState } from "vuex";

export default {
  name: "Pay-member",
  components: {},
  data() {
    return {
      memberType: "",
      zhzt: [
        {
          sname: "全部",
          value: "",
        },
        {
          sname: "平台会员",
          value: 1,
        },
        {
          sname: "企业会员",
          value: 2,
        },
        {
          sname: "个人会员",
          value: 3,
        },
      ],
      totalMember: 0,
      filterData: [],
      searchForm: {
        sname: "", // 会员名称
        bizUserid: "", // 会员ID
        isFlag: "", // 会员状态 （传空查询全部， 1是有效 0 是无效）
        // userName: '', // 创建人
        memberType: "", // 会员类型（传空 查询全部， 1 是平台会员，2是企业会员，3是个人会员）
        // isReal: '', // 是否实名（传空 查询全部， 1 是实名， 0 是否）
        startTime: "", // 开始时间
        endTime: "", // 结束时间(2020-08-09 格式)
      },
      loading: false,
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      dialogObj: {
        title: "",
        visible: false,
        width: "650px",
        mode: "",
      },
      dialogData: {},
      dialogData2: [],
      searchToggle: true,
      tableShow: true,

      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
    };
  },
  created() {
    this.getData();
  },
  methods: {
    //重置、刷新 筛选框
    resetSerach() {
      this.$refs.searchForm.resetFields();
      this.searchForm.endTime = "";
      this.currentPage = 1;
      this.pageSize = 10;
      this.getData();
    },

    //条件查询
    doSearch() {
      this.currentPage = 1;
      this.getData();
    },

    //获得列表数据
    getData() {
      let params = Object.assign({}, this.searchForm);
      this.loading = true;
      // 分页参数
      params.current = this.currentPage;
      params.size = this.pageSize;
      selectAllPage(params)
        .then((res) => {
          this.loading = false;
          this.filterData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.totalMember = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
          // 设置回显
          this.setChecked();
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    //筛选框重置
    handleClose() {
      this.dialogObj.visible = false;
    },

    //查看账号详情
    showDeatil(params) {
      this.dialogObj.visible = true;
      this.dialogObj.title = "会员详情";
      this.dialogObj.width = "900px";
      // this.dialogData = params
      this.dialogObj.mode = "detail";
      console.log(this.memberType);
      getDetails({
        id: params.id,
      }).then((res) => {
        this.dialogData = res.data;
      });
    },

    //查看银行卡
    showCard(params) {
      this.dialogObj.visible = true;
      this.dialogObj.title = "银行卡详情";
      this.dialogObj.width = "1200px";
      // this.dialogData = params
      this.memberType = params.memberType;
      this.dialogObj.mode = "showCard";
      getBankInfo({
        id: params.id,
      }).then((res) => {
        this.dialogData2 = res.data;
      });
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },

    // 是否展开搜索区域
    changeState() {
      this.searchToggle = !this.searchToggle;
    },

    // 登录账号提示
    alertMsg() {
      if (this.newAccount.phone == "") {
        this.$message.info("登录账号默认为手机号，请填写手机号！");
      }
    },

    // 开始时间的 pickOption
    beginDate() {
      let that = this;
      return {
        disabledDate(time) {
          let endTime = "";
          endTime = that.searchForm.endTime;
          if (endTime) {
            return bmElementTimeOptins.limitDateBefore(time, endTime, true);
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },

    // 结束时间的 pickOption
    processDate() {
      let that = this;
      return {
        disabledDate(time) {
          let startTime = "";
          startTime = that.searchForm.startTime;
          if (startTime) {
            let nowTime = Date.now();
            return bmElementTimeOptins.limitDateInRange(
              time,
              startTime,
              nowTime,
              true
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },
  },

  computed: {
    ...mapState("menu", {
      roleBtns: (state) => state.roleBtns,
    }),
  },

  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableShow = false;
      setTimeout(() => {
        this.tableShow = true;
      }, 50);
      setTimeout(() => {
        this.$refs.xTable.doLayout();
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.register-main {
  .filter-box {
    padding-top: 5px;
  }

  /deep/ .search-form {
    .el-form-item {
      margin-bottom: 5px;
    }
  }
  .content-header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
	  padding-left: 10px;
	  border-left: 4px solid #2671cc;
	  font-size: 14px;
	  color: #202020;
	}
	.blue{
	  font-size: 18px;
	  color: #2671cc;
	}
  }
  .pd5{
	padding: 0 5px;
  }
}
</style>
